"use client";

import Link from "next/link";
import React from "react";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import ImageAtom, { MagnoliaImage } from "@/components/atoms/image/image";
import RichText from "@/components/atoms/rich-text/rich-text";
import withBrand from "@/components/with-brand";
import { ReferFriendContentProps } from "@/types/confirmation-types";

import Styles from "./refer-friend-content.module.css";

function ReferFriendContent({
  referFriendTitle,
  referFriendContent,
  referFriendBtnLabel,
  referFriendImage,
  referFriendBtnLabelTwo,
  brand,
}: Readonly<ReferFriendContentProps>) {
  const imageProps: MagnoliaImage | undefined | null =
    typeof referFriendImage === "string"
      ? {
          "@id": "",
          "@link": referFriendImage,
          "@name": "",
          "@path": "",
          "@type": "",
          "@uuid": "",
        }
      : referFriendImage;

  const { current } = useWizard();

  return (
    <div data-testid="referFriendContent-testid" className=" ">
      {imageProps && (
        <div
          className={`${brand} ${Styles.image_block}  ${Styles.image_area} `}
        >
          <ImageAtom
            image={imageProps}
            styleClass=""
            height={
              current.brandSpecificParams
                ?.referFriendImageHeightForAVN as number
            }
            data-testid="refer-friend-image-testid"
          />
        </div>
      )}
      <div
        className={`${brand} ${Styles.referFriendBg} p-spacing-m md:p-spacing-xl space-y-spacing-m md:space-y-spacing-l md:relative rounded-b-radius-xxl`}
      >
        <h1 className="font-header-font text-text-title text-[23px] md:text-[31px] leading-[27.6px] md:leading-[34.1px] md:w-[400px] ">
          <RichText richText={referFriendTitle ?? ""} />
        </h1>
        <div className={`text-2xs font-normal leading-6 text-text-body `}>
          <RichText
            richText={referFriendContent ?? ""}
            className={`${Styles.richtext} md:w-[379px]`}
          />
        </div>
        <div className="">
          {referFriendBtnLabelTwo && (
            <Link
              href={referFriendBtnLabelTwo}
              target="_blank"
              className="w-full"
            >
              <LabelButtonWrapper
                data-testid="refer-friend-button"
                id="refer-friend-button"
                isDisabled={false}
                label={referFriendBtnLabel ?? ""}
                hierarchy="secondary"
                className="!w-fit px-spacing-l py-spacing-s bg-dark-text-on-secondary"
                type="button"
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default withBrand(ReferFriendContent);
